import checkTypes from "check-types";
import Chunk from "components/organisms/editor/core/model/lib/chunk";

const { assert } = checkTypes;

/**
 * The ChunkResponse allows for additional data to be sent back with the chunk
 * at present there are no extra data to send.
 */
class ChunkResponse {
    constructor(chunk) {
        assert.instance(chunk, Chunk);
        this.chunk = chunk;
    }

    toRaw() {
        return {
            chunk: this.chunk.toRaw(),
        };
    }

    static fromRaw(raw) {
        if (!raw) return null;

        return new ChunkResponse(Chunk.fromRaw(raw.chunk));
    }

    getChunk() {
        return this.chunk;
    }
}

export default ChunkResponse;
